import { useState } from 'react';
import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

import { isProductMember } from '../../lib/membership';

const query = gql`
  query MembershipStatus {
    me {
      id
      isWaybetterMember
    }
  }
`;

export function useMembershipStatusQuery(gameType, skip = false) {
  const [isCompleted, setCompleted] = useState(false);

  const { data, error, loading } = useQuery(query, {
    fetchPolicy: 'network-only',
    skip,
    onCompleted: () => setCompleted(true),
    ssr: false,
  });

  if (loading) return { loading: true };
  if (error) return { error, loading };

  const isActiveMemberForProduct = isProductMember({
    product: gameType,
    isActiveWbMember: data?.me?.isWaybetterMember,
  });

  return {
    isCompleted,
    isActiveMemberForProduct,
    loading,
  };
}
